import React from 'react'
import BaseInputComponent from './BaseInputComponent'
import Icon from 'react-fa'

import { t } from '../../helpers/translate.js'

class ButtonComponent extends BaseInputComponent {

  render() {
    const buttonName = this.props.as || 'Button';
    return !this.props.editMode && <div className={`form-group ${this.state.isInvalid ? t('has-error') : ''}`}>
      <button className="btn button-secondary button-minor" onClick={this.props.buttonAction.bind(this, this.props.keyPath[1])}>
        <Icon name={this.props.iconLabel} className="mr-1" />
        {t(buttonName)}
      </button>
    </div>
  }
}

ButtonComponent.displayName = 'ButtonComponent';
export default ButtonComponent;



// WEBPACK FOOTER //
// ./src/components/common/ButtonComponent.js